module.exports = __webpack_public_path__ + "media/images/logo-small-6dc09e7d9a3179be8e5d4a0fb350ec51.png";